module.exports = __webpack_public_path__ + "static/img/B智驾域控制器SDC200.b821f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/智能碰撞预警系统/B智驾域控制器SDC200.png
// module id = L896
// module chunks = 0